<template>
  <div id="fbButton" 
    class="validacion"
    v-bind:class="[isForResponsive]"
    @click="doLogin">
    <!-- <img class="fblogo" :src="fbIconImage" /> -->
    <span>CLICK AQUÍ</span>
  </div>
</template>

<script>
import { sha256 } from 'js-sha256';
import fbIcon from "@/assets/facebook-icon.png";

export default {
  name: "FacebookButton",
  data() {
    return {
      fbIconImage: fbIcon,
    }
  },
  props: {
    isForResponsive: ''
  },
  methods: {
    // doLogin: function() 
    // {
    //   var vm = this;
    //   window.FB.login(
    //     (response) => {
    //       if (response.status === "connected") {
    //         //const appsecret_proof = this.hmacHash(response.authResponse.accessToken, '7a49eeecde7f9786b5c6db5161ed3825')
    //         console.log('Verificando su información.... ');
    //         window.FB.api(
    //           //`/me?fields=birthday,email,name&appsecret_proof=${appsecret_proof}`,
    //           `/me?fields=age_range,email,name`,
    //           function (meResponse) {
    //             const xeerpaNeeded = {
    //               ...response,
    //               //birthday: meResponse.birthday
    //               age_range: meResponse.age_range,
    //             };
    //             //meResponse.birthday
    //             meResponse.age_range
    //               ? vm.$emit("fbLogin", xeerpaNeeded)
    //               : vm.$emit("noBirthdayInFacebook");
    //           }
    //         );
    //       }
    //     },
    //     //{ scope: "public_profile,email,user_birthday,user_likes" }
    //     { scope: "public_profile,email,user_age_range,user_likes" }
    //   );
    // },
    doLogin: function () {
      var vm = false;
      window.location.href = 'https://login.heinekenmexico.com/millerhighlife'
    },
    hmacHash(userToken, appSecret) {
      const hash = sha256.hmac.create(appSecret)
      const appsecret_proof = hash.update(userToken).hex();
      return appsecret_proof;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";

#fbButton {
  font-family: $font-dinbold;
  border: 4px solid $dark-color;
  margin-top: 8px;
  margin-left: 5px;
  padding: 5px 5px !important;

  width: 87.5%;

  display: flex;
  justify-content: center;
  align-items: center;
  background: $light-color;
  align-self: center;
  cursor: pointer;
  color: $dark-color;
  height: 35px !important;
  img {
    height: 25px;
    width: auto;
    margin-right: 10px;
  }
  &:focus {
    border-color: $darker-color;
  }
  &.desktop {
    margin-top: 0px;
    img {
      margin-left: 0.8rem;
    }
  }
}

.mobile {
  display: none !important;
}

@media (min-width: 1400px) and (max-width: 3000px) {
  #fbButton {
    width: 85.6%;
  }
}

@media (min-width: 320px) and (max-width: 768px) {
  .desktop {
    display: none !important;
  }
  .mobile {
    display: flex !important;
  }
  #fbButton {
    align-self: flex-end;
    padding: 5px 10px;
    img, span {
      margin-right: 6px;
    }
    &.mobile {
      margin-top: 0rem;
      align-self: flex-start;
      // margin-left: 3rem;
    }
  }
}

@media (min-width: 320px) and (max-width: 600px) {
  #fbButton {
      img, span {
        margin-left: 1rem;
      }
      img {
        margin-right: 5px;
      }
      span {
        margin-right: 2.2rem;
        margin-left: 0.5rem;
      }
      &.mobile {
      margin-top: 0rem;
      align-self: flex-start;
      margin-left: 0rem;
      width: 89%;
      text-align: center;
      span {
        font-size: 0.8rem;
        margin: 0px;
      }
    }
  }
}
</style>